import { Pipe, PipeTransform } from "@angular/core";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { Tradable } from "@models/interfaces/tradable";
import { DEFAULT_LOGO_URL } from "@helpers/constants";

@Pipe({
	name: "assetIcon",
	standalone: false
})
export class AssetIconPipe implements PipeTransform {
	public constructor(private tradableListService: TradableListService) {}

	public transform(id: string): string {
		const tradable: Tradable = this.tradableListService.getItemById(id);
		return tradable?.getLogo() || DEFAULT_LOGO_URL;
	}
}
